<template>
    <span 
      class="button-back touch"
      :class="{ 'button-back--disable': isTopLevelNav }"
      @click="handleBack"
    >
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" fill="currentColor">
      <path
        d="M18.2 273l-17-17 17-17L171.8 85.4l17-17 33.9 33.9-17 17L93.1 232 424 232l24 0 0 48-24 0L93.1 280 205.8 392.6l17 17-33.9 33.9-17-17L18.2 273z"
      />
    </svg>
    <div>{{ config.labels.backButton[language.code] }}</div>
  </span>
</template>
<script>
import { mapGetters, mapState } from 'vuex'
import {
  buildLivingOptionPath,
  buildSubsectionPath,
  getLivingBasePath,
  isLivingEntryRoute,
  isLivingOptionRoute,
  isSubsectionRoute,
} from '@/utils/livingRoute'

export default {
  computed: {
    ... mapState({
      labels: 'labels'
    }),

    ...mapGetters({
      backlink: 'activeBackLink',
      language: 'language',
      config: 'newConfig'
    }),

    isTopLevelNav () {
      let isTopLevelNav = false
      if (isLivingEntryRoute(this.$route.name)) isTopLevelNav = true
      this.$store.getters.activeBottomBar.forEach(item => {
        if (item.pageId === this.$route.params.pageId) isTopLevelNav = true
      })
      return isTopLevelNav
    },

    isSubLevelNav () {
      let isSubLevelNav = false
      if (this.$store.getters.activeSubBottomBar) {
        this.$store.getters.activeSubBottomBar.forEach(item => {
          if (item.pageId === this.$route.params.pageId) isSubLevelNav = true
        })
      }
      return isSubLevelNav
    }
  },

  methods: {
    handleBack() {
      if (this.isTopLevelNav) return

      if (this.isSubLevelNav) {
        this.$store.getters.activeBottomBar.forEach(item => {
          item.children.forEach(child => {
            if (child.pageId === this.$route.params.pageId) {
              this.$router.push(`/category/${this.$route.params.categoryId}/page/${item.pageId}`)
            }
          })
        })
      } else if (isLivingOptionRoute(this.$route.name)) {
        const livingEntryOptions = this.$store.getters['property/activeLivingEntryOptions']
        if (this.config.skipOnlyChildLivingOptions && livingEntryOptions.length === 1) {
          this.$router.push(this.backlink)
          return
        }

        this.$router.push(getLivingBasePath(this.$route))
      } else if (isSubsectionRoute(this.$route.name)) {
        if (this.$store.getters['property/activeSubsection'].parent.type === 'livingOption') {
          const livingOptionSubsections = this.$store.getters['property/livingOptionSubsections']
          if (this.config.skipOnlyChildSubsections && livingOptionSubsections.length === 1) {
            this.$router.push(this.backlink)
          } else {
            this.$router.push(buildLivingOptionPath(this.$route, this.$route.params.livingOptionId))
          }
        } else if (this.$store.getters['property/activeSubsection'].parent.type === 'subsection') {
          this.$router.push(buildSubsectionPath(this.$route, this.$route.params.livingOptionId, this.$store.getters['property/activeSubsection'].parent.id))
        } else {
          this.$router.go(-1)
        }
      } else {
        this.$router.go(-1)
      }
    }
  }
}
</script>
<style lang="scss">
  .button-back {
    align-items: center;
    border: 0.1rem solid #fff;
    border-radius: var(--border-radius);
    font-size: var(--button-font-size);
    height: var(--button-height);
    display: flex;
    padding: var(--button-padding);
    text-transform: uppercase;

    &--disable {
      pointer-events: none;
      opacity: 0.2;
    }

    svg {
      margin: 0 1rem 0 0;
      width: 1.2rem;
    }
  }
</style>
